import React from 'react';

const JournalTypeListing = ({ data, onEdit, onDelete, isLoading, searchQuery }) => {
    return (
        <div
            className="table-card"
            style={{
                overflowX: 'auto',
                WebkitOverflowScrolling: 'touch',
                background: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                paddingBottom: '10px'
            }}
        >
            <table className="custom-table" style={{ minWidth: '1100px' }}>
                <thead>
                    <tr>
                        <th width="5%" style={{ textAlign: 'center' }}>STT</th>
                        <th width="30%">LOẠI TẠP CHÍ</th>
                        <th width="10%" style={{ textAlign: 'center' }}>ĐIỂM CÔNG TRÌNH</th>
                        <th width="10%" style={{ textAlign: 'center' }}>ĐƯỢC TÍNH THƯỞNG</th>
                        <th width="15%" style={{ textAlign: 'center' }}>TIỀN THƯỞNG BÀI BÁO</th>
                        <th width="15%" style={{ textAlign: 'center' }}>THƯỞNG TÁC GIẢ CHÍNH</th>
                        <th width="15%" style={{ textAlign: 'center' }}>CHỨC NĂNG</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <tr>
                            <td colSpan="7" style={{ textAlign: 'center', padding: '60px', color: '#003399' }}>
                                <i className="fa-solid fa-circle-notch fa-spin" style={{ fontSize: '35px', marginBottom: '15px', display: 'block' }}></i>
                                Đang tải dữ liệu
                            </td>
                        </tr>
                    ) :
                        !Array.isArray(data) || data.length === 0 ? (
                            <tr>
                                <td colSpan="7" style={{ textAlign: 'center', padding: '50px', color: '#888' }}>
                                    <i className="fa-solid fa-magnifying-glass-minus" style={{ fontSize: '30px', display: 'block', marginBottom: '15px', color: '#ccc' }}></i>
                                    {(!Array.isArray(data)) ? "Lỗi dữ liệu hoặc chưa được cấp quyền" : "Không tìm thấy loại tạp chí nào phù hợp"}
                                </td>
                            </tr>
                        ) : (
                            data.map((item, index) => (
                                <tr key={item.Id}>
                                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                    <td style={{ fontWeight: '500' }}>{item.Name}</td>
                                    <td style={{ textAlign: 'center' }}>{item.Score}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        {item.IsRewarded ? <i className="fa-solid fa-circle-check" style={{ color: '#28a745' }}></i> : ''}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>{item.PaperReward.toLocaleString()}</td>
                                    <td style={{ textAlign: 'center' }}>{item.MainAuthorReward.toLocaleString()}</td>
                                    <td>
                                        <div className="action-group">
                                            <div className="icon-wrapper edit-wrapper" onClick={() => onEdit(item)}>
                                                <i className="fa-solid fa-pen edit-icon"></i>
                                            </div>
                                            <div className="icon-wrapper delete-wrapper" onClick={() => onDelete(item.Id)}>
                                                <i className="fa-solid fa-trash delete-icon"></i>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                </tbody>
            </table>
        </div>
    );
};

export default JournalTypeListing;